import type { TeamMemberRole } from "~graphql/generated/graphql"
import { usePublicTeamMembersQuery } from "~graphql/generated/graphql"

export default function usePublicTeamMembers({
    outfitterId,
    role,
}: {
    outfitterId: string | null
    role?: TeamMemberRole | null
}) {
    const {
        data: results,
        loading: isLoading,
        error,
    } = usePublicTeamMembersQuery({
        variables: {
            outfitterId: outfitterId ?? "",
            role: role ?? undefined,
        },
        skip: !outfitterId,
    })
    const teamMembers = results?.publicTeamMembers.data ?? []

    return { teamMembers, isLoading, error }
}
